function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var t = /^(?:0|[1-9]\d*)$/;
function s(e) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_SAFE_INTEGER;
  switch (_typeof(e)) {
    case "number":
      return Number.isInteger(e) && e >= 0 && e < r;
    case "symbol":
      return !1;
    case "string":
      return t.test(e);
  }
}
export { s as isIndex };